import React, { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { Callout } from '@node-space/ui-components'

export type SubmitErrorProps = {
  children?: ReactNode
}

export const SubmitError = ({ children }: SubmitErrorProps) => {
  const { t } = useTranslation()

  return <Callout variant="error">{children || t('oopsSomethingWentWrong')}</Callout>
}
